import { Dispatch } from "react";
import * as actionTypes from "redux/actionTypes/Index";
import {
  IActionType,
  ICreateCampaignRequestPayload,
  IGetQueryParams,
  IFetchCampaignActionResponse,
} from "interfaces/Index";
import {
  createCampaignApiCall,
  getCampaignsApiCall,
  updateCampaignApiCall,
} from "redux/sources/CampaignSource";
import { CAMPAIGN_TYPE } from "config/constants";
import { uploadImageApiCall } from "utils/UploadImage";

export const createCampaignInit = () => ({
  type: actionTypes.CREATE_CAMPAIGN_INIT,
});

export const createCampaignSuccess = () => ({
  type: actionTypes.CREATE_CAMPAIGN_SUCCESS,
});
export const createCampaignFail = (error: string | object | null) => ({
  type: actionTypes.CREATE_CAMPAIGN_FAIL,
  error,
});

export const getCampaignsInit = () => ({
  type: actionTypes.GET_CAMPAIGNS_INIT,
});

export const getCampaignsSuccess = (payload: IFetchCampaignActionResponse) => ({
  type: actionTypes.GET_CAMPAIGNS_SUCCESS,
  payload,
});
export const getCampaignsFail = (error: string | object | null) => ({
  type: actionTypes.GET_CAMPAIGNS_FAIL,
  error,
});

export const updateCampaignInit = () => ({
  type: actionTypes.UPDATE_CAMPAIGN_INIT,
});

export const updateCampaignSuccess = () => ({
  type: actionTypes.UPDATE_CAMPAIGN_SUCCESS,
});
export const updateCampaignFail = (error: string | object | null) => ({
  type: actionTypes.UPDATE_CAMPAIGN_FAIL,
  error,
});

export const createCampaign =
  (payload: ICreateCampaignRequestPayload) =>
    (dispatch: Dispatch<IActionType>) => {
      dispatch(createCampaignInit());
      if (payload.type === CAMPAIGN_TYPE.BRAND_VALUE && payload.campaignImage) {
        return uploadImageApiCall("campaign", payload.campaignImage).then((data) => {
          payload.imageId = data.id || "";
          return createCampaignApiCall(payload)
            .then(() => dispatch(createCampaignSuccess()))
        });
      } else {
        return createCampaignApiCall(payload)
          .then(() => dispatch(createCampaignSuccess()))
          .catch((e) => dispatch(createCampaignFail(e)));
      }
    };

export const getCampaigns =
  (queryParams?: IGetQueryParams) => (dispatch: Dispatch<IActionType>) => {
    dispatch(getCampaignsInit());
    return getCampaignsApiCall(queryParams)
      .then((response: any) => dispatch(getCampaignsSuccess(response)))
      .catch((e: any) => dispatch(getCampaignsFail(e)));
  };

export const updateCampaign =
  (campaignId: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(updateCampaignInit());
    return updateCampaignApiCall(campaignId)
      .then(() => dispatch(updateCampaignSuccess()))
      .catch((e) => dispatch(updateCampaignFail(e)));
  };
